module.exports = __webpack_public_path__ + "img/12.fb175466.png";